export default {
  ALERT_DISPLAY(state, message) {
    const newState = state;

    newState.alert = message;
  },
  ALERT_HIDE(state) {
    const newState = state;

    newState.alert = null;
  },
};
